import { SplitsDialogContent } from '~/components/component-library/Dialog'
import { useCards } from '~/hooks/useCards'
import { Card } from '~/types/cards'
import { shortenAddress } from '~/utils/addresses'

type RemoveCardDialogContentProps = {
  card: Card
  closeDialog: () => void
}

export const RemoveCardDialogContent = ({
  card,
  closeDialog,
}: RemoveCardDialogContentProps) => {
  const { removeCard, isRemoving } = useCards()

  const handleRemove = async () => {
    await removeCard(card.address)
    closeDialog()
  }

  return (
    <SplitsDialogContent
      id="removeCard"
      title={`Remove ${shortenAddress(card.address)}?`}
      variant="destructive"
      deleteButton={{
        text: 'Remove',
        onClick: handleRemove,
        isDisabled: isRemoving,
      }}
    >
      <p>This card will be removed from your org&apos;s cards list.</p>
    </SplitsDialogContent>
  )
}
